import {
  IChartSettings,
  IParsedChartDataFunnel,
  IMeasurableSliceColumn,
} from '../../../interfaces';
import {
  IChartLine,
  filterVisibleColumnsBySliceAndMeasure,
} from '../../useChartLines';
import {
  getMeasureColorFromColorConfig,
  getSliceColorFromColorConfig,
  IAnalysisColorConfig,
} from '../../../utils/analysisColorConfig';

export default (
  sortedColumns: IMeasurableSliceColumn[],
  chartData: IParsedChartDataFunnel,
  chartSettings: IChartSettings,
  colorConfig: IAnalysisColorConfig,
  shouldUseMeasureColor: boolean,
): IChartLine[] => {
  const { linesMeta, measureControls } = chartData;
  const { isFunnelClusterMode } = chartSettings;
  const visibleColumns = filterVisibleColumnsBySliceAndMeasure(
    sortedColumns,
    chartSettings,
  );

  // for cluster mode, we need to order by step.
  // for example:
  // original: group1.step1 group2.step1 => group1.step2 group2.step2
  // cluster:  group1.step1 group2.step1 => group2.step2 group2.step2
  const reorderedColumns = isFunnelClusterMode
    ? visibleColumns.sort(
        (a, b) =>
          measureControls.findIndex((mc) => mc.key === a.measureKey) -
          measureControls.findIndex((mc) => mc.key === b.measureKey),
      )
    : visibleColumns;
  return reorderedColumns.map((column) => {
    const color = shouldUseMeasureColor
      ? getMeasureColorFromColorConfig(colorConfig, column.measureKey)
      : getSliceColorFromColorConfig(colorConfig, column.sliceKey);

    return {
      name: column.key,
      display: linesMeta[column.key]?.display,
      color,
      type: 'normal',
      measureKey: column.measureKey,
    };
  });
};
